import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Avatar, Paper, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { generateImageUrlFromCDN } from '../Util';

const CATEGORIES = [
    'pop', 'classic rock', '60s', '70s', '80s', '90s',
    'hip hop', 'country', 'indie', 'rnb', 'hard rock', 'k-pop'
];

const WeeklyQuizzesSelector = ({ selectedWeek, setSelectedWeek, assignments, onCategorySelect }) => {
    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h6">Selection</Typography>
            <Paper elevation={10} sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Week (Monday)"
                        value={selectedWeek}
                        onChange={(newValue) => {
                            if (newValue) {
                                // Snap to Monday of the selected week
                                const monday = newValue.startOf('week').add(1, 'day');
                                setSelectedWeek(monday);
                            }
                        }}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                            },
                        }}
                    />
                </LocalizationProvider>

                <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 'bold' }}>
                    Categories
                </Typography>
                <List sx={{ width: '100%', py: 0 }}>
                    {/* Featured Category */}
                    {(() => {
                        const featuredAssignment = assignments[selectedWeek?.format('YYYY-MM-DD')]?.['featured'];
                        return (
                            <ListItem
                                sx={{
                                    py: 1,
                                    px: 1,
                                    mb: 1,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: '#fff9c4', // Light yellow for highlighting
                                    borderRadius: 1,
                                    border: '1px solid #fbc02d'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {featuredAssignment && (
                                        <Avatar
                                            alt={featuredAssignment.label}
                                            src={generateImageUrlFromCDN(featuredAssignment.shareImageMetadata)}
                                            sx={{ width: 24, height: 24 }}
                                        />
                                    )}
                                    <ListItemText
                                        primary="FEATURED"
                                        secondary={featuredAssignment ? featuredAssignment.label : 'No quiz selected'}
                                        primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: 800, color: '#f57f17' }}
                                        secondaryTypographyProps={{
                                            fontSize: '0.75rem',
                                            color: featuredAssignment ? 'inherit' : 'red'
                                        }}
                                    />
                                </Box>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="warning"
                                    onClick={() => onCategorySelect('featured')}
                                >
                                    {featuredAssignment ? 'Change' : 'Select'}
                                </Button>
                            </ListItem>
                        );
                    })()}

                    {CATEGORIES.map((cat) => {
                        const assignment = assignments[selectedWeek?.format('YYYY-MM-DD')]?.[cat];
                        return (
                            <ListItem
                                key={cat}
                                sx={{
                                    py: 0.5,
                                    px: 1,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    borderBottom: '1px solid #eee'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {assignment && (
                                        <Avatar
                                            alt={assignment.label}
                                            src={generateImageUrlFromCDN(assignment.shareImageMetadata)}
                                            sx={{ width: 24, height: 24 }}
                                        />
                                    )}
                                    <ListItemText
                                        primary={cat.toUpperCase()}
                                        secondary={assignment ? assignment.label : 'No quiz selected'}
                                        primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: 600 }}
                                        secondaryTypographyProps={{
                                            fontSize: '0.75rem',
                                            color: assignment ? 'inherit' : 'red'
                                        }}
                                    />
                                </Box>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => onCategorySelect(cat)}
                                >
                                    {assignment ? 'Change' : 'Select'}
                                </Button>
                            </ListItem>
                        );
                    })}
                </List>
            </Paper>
        </Box>
    );
};

export default WeeklyQuizzesSelector;
